import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M8.533 12.267h0.267c1.027 0 1.867 0.84 1.867 1.867v9.333c0 1.027-0.84 1.867-1.867 1.867h-0.267c-1.027 0-1.867-0.84-1.867-1.867v-9.333c0-1.027 0.84-1.867 1.867-1.867zM16 6.667c1.027 0 1.867 0.84 1.867 1.867v14.933c0 1.027-0.84 1.867-1.867 1.867s-1.867-0.84-1.867-1.867v-14.933c0-1.027 0.84-1.867 1.867-1.867zM23.467 17.333c1.027 0 1.867 0.84 1.867 1.867v4.267c0 1.027-0.84 1.867-1.867 1.867s-1.867-0.84-1.867-1.867v-4.267c0-1.027 0.84-1.867 1.867-1.867z" })
});
export default SvgBarChart;
